import apiRequest, { API_URLS } from "./api";

export const loginService = async (email, password) => {
  const data = await apiRequest(API_URLS.auth.login, "POST", {
    email,
    password,
  });

  if (data?.data?.accessToken) {
    localStorage.setItem("accessToken", data.data.accessToken);
    localStorage.setItem("user", JSON.stringify(data.data.user));
  }

  return data;
};

export const logoutService = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const getToken = () => {
  return localStorage.getItem("accessToken");
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("accessToken");
};
